import React from 'react';
import { connect } from 'react-redux';
import ExploitabilityField from '~/artifact/components/ArtifactExploitabilityField';

const convertToPercentageString = (value: number | null) => {
  return value ? `${(value * 100).toFixed(2)}%` : null;
};

const convertToOrdinalNumberString = (value: number | null) => {
  if (typeof value === 'number' && value >= 0 && value <= 1) {
    const roundedDownPercentile = getRoundedDownPercentile(value);
    return roundedDownPercentile + getOrdinalNumberSuffix(roundedDownPercentile);
  } else {
    return null;
  }
};

const getRoundedDownPercentile = (value: number) => {
  const percentile = value * 100;
  if (percentile >= 99.5) {
    return Math.floor(percentile);
  } else {
    return Math.round(percentile);
  }
};

const getOrdinalNumberSuffix = (value: number): string => {
  const lastDigit = value % 10;
  const lastTwoDigits = value % 100;

  if (lastTwoDigits === 11 || lastTwoDigits === 12 || lastTwoDigits === 13) {
    return 'th';
  } else if (lastDigit === 1) {
    return 'st';
  } else if (lastDigit === 2) {
    return 'nd';
  } else if (lastDigit === 3) {
    return 'rd';
  } else {
    return 'th';
  }
};

const convertToYesNoString = (bool: boolean) => {
  return bool ? 'Yes' : 'No';
};

type ArtifactViewMainContentExploitsProps = {
  actions: object;
  artifactState: object;
  artifact: object;
}

class ArtifactViewMainContentExploits extends React.Component<
  ArtifactViewMainContentExploitsProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const {
      artifactState: {
        exploitability: {
          epss_score,
          epss_percentile,
          exploit_observed,
          exploit_source,
          exploit_note
        }
      }
    } = this.props;
    return (
      <section className="grid">
        <ExploitabilityField fieldName={'EPSS Score'} fieldValue={convertToPercentageString(epss_score)} />
        <ExploitabilityField fieldName={'EPSS Percentile'} fieldValue={convertToOrdinalNumberString(epss_percentile)} />
        <ExploitabilityField fieldName={'Exploit Observed'} fieldValue={convertToYesNoString(Boolean(exploit_observed))} />
        <ExploitabilityField fieldName={'Exploit Source'} fieldValue={exploit_source} />
        <ExploitabilityField fieldName={'Exploit Notes'} fieldValue={exploit_note} />
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}

export default connect(
  mapStateToProps
)(ArtifactViewMainContentExploits);
